import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Cancellation Policies",
  translation: { displayName: "Translations" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "filterOptionPosition",
        displayName: "Order",
      },
      {
        fieldName: "active",
        displayName: "Active",
        restrictionMessage: "Policy linked to a condition. It is not possible to perform this action",
      },
      {
        fieldName: "dates",
        displayName: "Dates",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "validFrom",
        placeholder: "Enter a date",
        displayName: "Start date",
        tooltip:
          "This date refers to the time at which the stay will take place (travel window). The policy will be activated if the desired check-in and check-out dates are within the range",
      },
      {
        fieldName: "validTo",
        placeholder: "Enter a date",
        displayName: "End date",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "configurations",
        displayName: "Constraints",
        introductionText: [
          "Create different penalties depending on the anticipation of cancellation",
          "Important! Check that the policies are correctly applied in the engine"
        ],
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
    ],
  },
};
